// Vacuum Genie PDP: kit selection, add-to-cart, countdown, sticky bars, gallery, accordions.
(function () {
  function init(root) {
    if (!root) return;

    // ---- Kit card selection ----
    var kits = root.querySelectorAll('[data-vg-kit]');
    var selected = root.querySelector('[data-vg-kit].is-selected') || kits[0];

    function saveLabelFor(card) {
      // Read the % off the card's own "YOU SAVE X%" chip so the label follows
      // whichever offer set (vg-1 or vg-2) rendered the cards.
      var chip = card.querySelector('.vg-kit-save');
      var m = chip && chip.textContent.match(/(\d+)\s*%/);
      if (m) return 'save ' + m[1] + '%';
      return card.dataset.vgName === 'Value Bundle' ? 'save 41%' : 'save 30%';
    }

    function applySelection(card) {
      selected = card;
      kits.forEach(function (k) {
        k.classList.remove('is-selected');
        // Inline fallback so the radio fill never depends on cached CSS
        var dot = k.querySelector('.vg-kit-dot');
        var ring = k.querySelector('.vg-kit-radio');
        if (dot) dot.style.background = 'transparent';
        if (ring) ring.style.borderColor = '#C9BBA3';
      });
      card.classList.add('is-selected');
      var sdot = card.querySelector('.vg-kit-dot');
      var sring = card.querySelector('.vg-kit-radio');
      if (sdot) sdot.style.background = '#000';
      if (sring) sring.style.borderColor = '#000';
      root.querySelectorAll('[data-vg-summary-name]').forEach(function (el) { el.textContent = card.dataset.vgName; });
      root.querySelectorAll('[data-vg-summary-price], [data-vg-price-line]').forEach(function (el) { el.textContent = card.dataset.vgPrice; });
      root.querySelectorAll('[data-vg-summary-compare], [data-vg-compare-line]').forEach(function (el) { el.textContent = card.dataset.vgCompare; });
      root.querySelectorAll('[data-vg-selected-name]').forEach(function (el) { el.textContent = card.dataset.vgName; });
      root.querySelectorAll('[data-vg-save-label]').forEach(function (el) { el.textContent = saveLabelFor(card); });
    }

    kits.forEach(function (card) {
      card.addEventListener('click', function () { applySelection(card); });
    });

    // Sync price / name / labels to whichever card is selected on load.
    if (selected) applySelection(selected);

    // ---- Add to cart ----
    root.querySelectorAll('[data-vg-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!selected) return;
        var variantId = parseInt(selected.dataset.vgVariantId, 10);

        // Optimistic: open the drawer immediately with the selected kit rendered
        // (vg-cart's opt-add event) instead of waiting out the server round trip.
        // Falls back to the old flow when the kit card lacks data-vg-opt-* data.
        var od = selected.dataset;
        var optimistic = false;
        if (od.vgOptPrice) {
          var det = {
            id: variantId, qty: 1,
            title: od.vgOptTitle || od.vgName || '', handle: od.vgOptHandle || '',
            image: od.vgOptImage || '', url: '',
            price: parseInt(od.vgOptPrice, 10) || 0
          };
          if (det.id && det.price) {
            optimistic = true;
            document.dispatchEvent(new CustomEvent('vg:cart:open'));
            document.dispatchEvent(new CustomEvent('vg:cart:opt-add', { detail: det }));
          }
        }
        if (!optimistic) btn.style.opacity = '.6';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            btn.style.opacity = '';
            if (optimistic) {
              document.dispatchEvent(new CustomEvent('vg:cart:opt-settle'));
            } else {
              document.dispatchEvent(new CustomEvent('vg:cart:open'));
              document.dispatchEvent(new CustomEvent('vg:cart:changed'));
            }
          })
          .catch(function (err) {
            btn.style.opacity = '';
            // Settle refreshes from the server, removing the line it never got.
            if (optimistic) document.dispatchEvent(new CustomEvent('vg:cart:opt-settle'));
            console.error('[vg-pdp] add to cart failed', err);
            alert('Sorry, something went wrong adding to cart. Please try again.');
          });
      });
    });

    // ---- Cart icon opens drawer ----
    root.querySelectorAll('[data-vg-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('vg:cart:open'));
      });
    });

    // ---- Mobile sticky "Claim Offer": smooth-scroll to the buy box instead of
    // adding (same pattern as mg2-pdp.js — native smooth honours reduced-motion;
    // the timeout is a safety net for hidden pages, plus one correction pass in
    // case lazy media mounting mid-flight shifts the target).
    function vgScrollToOffer(isCorrection) {
      var offer = document.getElementById('vg-offer');
      if (!offer) return;
      var off = parseFloat(getComputedStyle(offer).scrollMarginTop) || 0;
      var startY = window.pageYOffset;
      var targetY = Math.max(0, offer.getBoundingClientRect().top + startY - off);
      if (Math.abs(targetY - startY) < 2) return;
      offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - startY) < 4) window.scrollTo(0, targetY);
        if (isCorrection === true) return;
        var want = Math.max(0, offer.getBoundingClientRect().top + window.pageYOffset - off);
        if (Math.abs(want - window.pageYOffset) > 80) vgScrollToOffer(true);
      }, 750);
    }
    root.querySelectorAll('[data-vg-sticky-scroll]').forEach(function (btn) {
      btn.addEventListener('click', vgScrollToOffer);
    });

    // ---- Countdown to midnight ----
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(23, 59, 59, 999);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      root.querySelectorAll('[data-vg-cd-h]').forEach(function (el) { el.textContent = pad(Math.floor(d / 3600)); });
      root.querySelectorAll('[data-vg-cd-m]').forEach(function (el) { el.textContent = pad(Math.floor((d % 3600) / 60)); });
      root.querySelectorAll('[data-vg-cd-s]').forEach(function (el) { el.textContent = pad(d % 60); });
    }
    tick();
    setInterval(tick, 1000);

    // ---- Ships by (tomorrow) ----
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    var shipsBy = tomorrow.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    root.querySelectorAll('[data-vg-ships-by]').forEach(function (el) { el.textContent = shipsBy; });

    // ---- Sticky bars at 40% scroll ----
    var stickies = root.querySelectorAll('[data-vg-sticky]');
    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var on = max > 0 && (window.scrollY / max) >= 0.4;
      stickies.forEach(function (el) { el.classList.toggle('is-on', on); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // ---- Mobile gallery thumbs ----
    var mainImg = root.querySelector('[data-vg-mobile-main]');
    root.querySelectorAll('[data-vg-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-vg-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg && thumb.dataset.vgFull) mainImg.src = thumb.dataset.vgFull;
      });
    });

    // ---- Accordions ----
    root.querySelectorAll('[data-vg-acc]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.vg-acc');
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.vg-acc.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var s = o.querySelector('[data-vg-acc-sign]');
          if (s) s.textContent = '+';
        });
        if (!open) {
          item.classList.add('is-open');
          var sign = item.querySelector('[data-vg-acc-sign]');
          if (sign) sign.textContent = '−';
        }
      });
    });

    // ---- Social strip auto-scroll (marquee) ----
    root.querySelectorAll('[data-vg-marquee]').forEach(function (row) {
      var originals = Array.prototype.slice.call(row.children);
      if (!originals.length) return;
      // Duplicate content so the loop can wrap seamlessly
      originals.forEach(function (el) { row.appendChild(el.cloneNode(true)); });
      var paused = false;
      ['mouseenter', 'touchstart', 'pointerdown'].forEach(function (ev) {
        row.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'touchend', 'pointerup'].forEach(function (ev) {
        row.addEventListener(ev, function () { paused = false; }, { passive: true });
      });
      var half = 0;
      function measure() { half = row.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);
      function step() {
        if (!paused) {
          row.scrollLeft += 0.6;
          if (half > 0 && row.scrollLeft >= half) row.scrollLeft -= half;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });

    // ---- FAQ ----
    root.querySelectorAll('[data-vg-faq]').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.vg-faq');
        var open = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.vg-faq.is-open').forEach(function (o) {
          o.classList.remove('is-open');
          var s = o.querySelector('[data-vg-faq-sign]');
          if (s) s.textContent = '+';
        });
        if (!open) {
          item.classList.add('is-open');
          var sign = item.querySelector('[data-vg-faq-sign]');
          if (sign) sign.textContent = '−';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-vg-pdp]').forEach(init);
  });
})();
